import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "SEO Services", desc: "Technical SEO · On-Page Optimisation · Local SEO · Content Strategy & Writing · Link Building" },
  { title: "Paid Services", desc: "Google Ads · Meta Ads · LinkedIn Ads · WhatsApp & SMS Marketing (India)" },
  { title: "Authority Building", desc: "Visibility that compounds through consistent content, optimisation, and distribution." },
];

const Seo = () => (
  <StitchFeaturePage
    label="SERVICE · SEO & DIGITAL MARKETING"
    title="Visibility that"
    titleAccent="compounds."
    subtitle="SEO, paid ads, and content that build lasting authority — not just a spike this month and silence the next."
    features={features}
    ctaLabel="PLAN YOUR GROWTH ENGINE"
  >
      </StitchFeaturePage>
);

export default Seo;
